<template>
  <section class="values-carousel-module-component">
    <div class="inner-container">
      <div class="top-content">
        <h2 v-html="props.data.title"></h2>

        <div class="carousel-container">
          <Splide
            ref="slider"
            :options="{
              autoHeight: true,
              rewind: true,
              type: 'fade',
              lazyLoad: 'nearby',
              arrow: true,
            }"
            :has-track="false"
            aria-label="Values Carousel">
            <div class="splide__arrows">
              <button class="splide__arrow splide__arrow--prev">
                <Arrow
                  direction="left"
                  :stroke-width="4"
                  color="dark-blue" />
              </button>
              <button class="splide__arrow splide__arrow--next">
                <Arrow
                  direction="right"
                  :stroke-width="4"
                  color="dark-blue" />
              </button>
            </div>

            <SplideTrack>
              <SplideSlide
                v-for="(carousel, idx) in data.carousel"
                :key="`carousel-${idx}`"
                class="carousel">
                <div class="image-container">
                  <img
                    :src="carousel.image.url"
                    alt="Image" />
                </div>

                <div
                  class="text-container"
                  v-html="carousel.content"></div>
              </SplideSlide>
            </SplideTrack>
          </Splide>
        </div>
      </div>
    </div>

    <div class="bottom-content">
      <div class="container">
        <BlurBG
          :blob-size="1.1"
          theme="dark">
          <template #default>
            <div
              class="bottom-container"
              v-html="data.blue_box_content"></div>
          </template>
        </BlurBG>
      </div>
    </div>
  </section>
</template>

<script setup>
/* #META
 {
  "NAME": "ValuesCarouselComponent",
  "CLASSNAME": "values-carousel-module-component",
  "URL": "http://vuevitewp.local/"
 }
#ENDMETA */

/*
 *   Insert your logic here
 */
import { ref } from 'vue'
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide'
import '@splidejs/vue-splide/css'
import Arrow from '../utility/Arrow.vue'
import BlurBG from '../utility/BlurBG.vue'

const props = defineProps(['data'])

const slider = ref(null)
</script>

<style lang="scss">
.values-carousel-module-component {
  @apply relative bg-bicara-white pt-9;

  .bottom-content {
    @apply -translate-y-8 px-xs lg:-translate-y-20 lg:px-xl;

    .bottom-container {
      @apply px-8 pb-[60px] pt-[80px] text-center lg:px-[160px] lg:pb-[80px] lg:pt-[160px];

      p {
        @apply quote leading-relaxed text-white;
      }
    }
  }

  .top-content {
    @apply relative mx-5 rounded-2xl bg-white pt-6;

    h2 {
      @apply header-5 relative mx-5 mb-6 text-center text-bicara-blue;
    }

    .carousel-container {
      @apply relative;

      .splide {
        @apply relative;

        .arrow-container {
          @apply absolute bottom-auto left-4 top-[337px] z-3 lg:top-[395px];

          &.right {
            @apply left-auto right-4;
          }

          .arrow-circle {
            @apply h-[45px] w-[45px] lg:h-[70px] lg:w-[70px];
          }
        }

        .splide__arrow {
          @apply bg-transparent opacity-100;
          svg {
            @apply fill-transparent;
          }
        }

        .splide__arrow--prev {
          @apply top-[360px] z-4 h-[45px] w-[45px] lg:top-[430px] lg:h-[70px] lg:w-[70px];
          @apply h-20 w-20;
          @apply left-2 lg:left-12;
        }

        .splide__arrow--next {
          @apply top-[360px] z-4 h-[45px] w-[45px] lg:top-[430px] lg:h-[70px] lg:w-[70px];
          @apply h-20 w-20;
          @apply right-2 lg:right-12;
        }

        .splide__pagination {
          @apply bottom-auto top-[360px] gap-2 lg:top-[450px] lg:gap-4;
        }

        .image-container {
          @apply h-[396px] lg:h-[500px];

          img {
            @apply h-full w-full object-cover object-center;
          }
        }

        .text-container {
          @apply relative px-6 py-6;

          p {
            @apply body-md text-center;

            strong {
              @apply header-4;
            }
          }
        }
      }
    }
  }
}
</style>
